import { Redirect } from "react-router-dom";
import { selectCurrentReservation } from "state/reservations/selectors";
import { selectLine } from "state/lines/selectors";
import { selectOffice } from "state/offices/selectors";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import moment from "moment-timezone";
import styled from "styled-components";
// Step 1
import { Calendar } from "antd";
import { useUnavailableDays } from "state/reservations/hooks";
// Step 3
import { ConfirmationModal } from "views/components/common/ConfirmationModal";
import { LoginButton } from "views/components/LoginButton";
import { LoginModal } from "views/mobile/screens/LoginModal";
import { SignUpModal } from "views/mobile/screens/SignUpModal";

import { Wizzard } from "views/components/Wizzard";
import { antLocale } from "lib/date";
import { pathOr } from "lib/functions";
import { useAuth } from "hooks/useAuth";
import { useGetReservation } from "hooks/useGetReservation";
import { useMemo } from "react";
import Provider from "views/components/RequestReservation";
import { ReservationDocumentModal } from "views/components/DocumentModal";

// todo: this component is too big. State management should be moved to independent
// components and files (cf. Step2 in this folder)
const RequestReservationScreen = ({
	activeSignUpModalInTemporaryUser,
	closeLoginModal,
	closeReserveWihtoutLogin,
	closeSignUpModal,
	documentModalType,
	handleMeet,
	handleOpenUpdateRutModal,
	handlerWithoutLoginModal,
	hasPhone,
	hasRut,
	history,
	isActiveLoginModal,
	isActiveRegistryModal,
	isDniRequired,
	isRutModalVisible,
	isRutRequired,
	isRutUpdating,
	isUnexistRequiredField,
	isVisibleConfirmationModal,
	isVisibleModalWithoutLogin,
	loginModalIsVisible,
	match,
	openRutUpdate,
	phoneRequired,
	rutOrDni,
	rutRequired,
	setIsRutModalVisible,
	setIsRutUpdating,
	setIsVisibleConfirmationModal,
	setMeetOrFace,
	setModalState,
	setOpenRutUpdate,
	setTemporaryDni,
	setTemporaryRut,
	setWantTemporary,
	showOnlyTemporaryForm,
	signUpModalIsVisible,
	temporaryDni,
	temporaryRut,
	ticketAction,
	user,
	wantTemporary,
}) => {
	const officeSlug = match.params.office;
	const lineSlug = match.params.line;
	const getOffice = useDispatch("requestOffice");
	const enqueueReservation = useDispatch("enqueueReservation");
	const [forms] = useGlobal("forms");
	const { isLoggedIn, isLoggedInTemporary } = useAuth();
	const finishReservationSaga = useDispatch("finishReservationSaga");
	const pickReserveSaga = useDispatch("pickReserveSaga");
	const getTimeBlocks = useDispatch("getTimeBlocks");
	const [chosenTimeBlock, setChoosenTimeblock] = useState(null);
	const formsPayload = pathOr({}, ["payload"], forms);
	const [offices] = useGlobal("officesv2");
	const [fieldsAnswers, setFieldAnswers] = useState({});
	const [lines] = useGlobal("linesv2");
	const [reservationsv2] = useGlobal("reservationsv2");
	const [myReservations] = useGlobal("myReservations");
	const [reservationQueue] = useGlobal("reserveQueue");

	const [reservationPayload, setReservationPayload] = useState(null);

	const [err, unavailableDaysLoading, unavailableDays] = useUnavailableDays(
		lineSlug,
		officeSlug
	);

	const office = selectOffice(offices, officeSlug);
	const line = selectLine(lines, lineSlug);
	const currentReservation = selectCurrentReservation(myReservations);
	const v2 = office ? office.options.reservations_v2 : null;
	const tz = office && office.timezone;
	const maxBookableDays =
		office &&
		(office.options.maxBookableDays || office.options.maxBookeableDays);
	const [step, setStep] = useState(0);
	const [selectedDate, setSelectedDate] = useState({
		date: moment(), // to do: timezone this
		from: "",
		to: "",
	});

	const [bookReservation, bookingLoading, bookingError] = useGetReservation(
		line && line.slug,
		officeSlug,
		line && line.id,
		v2
	);

	useEffect(() => () => finishReservationSaga({}), [finishReservationSaga]);

	useEffect(() => {
		getOffice({ officeSlug });
	}, [officeSlug, getOffice]);

	const loading = lines.isLoading || !line || unavailableDaysLoading;

	const handlerReservation = (payload) => {
		//Guardo el meta para enviar en los popups de ser necesario.
		setFieldAnswers(payload);

		return !isLoggedIn
			? isLoggedInTemporary
				? bookReservation(chosenTimeBlock, handleMeet(), payload)
				: showOnlyTemporaryForm
				? bookReservation(chosenTimeBlock, handleMeet(), payload)
				: isActiveLoginModal()
			: bookReservation(chosenTimeBlock, handleMeet(), payload);
	};
	if (currentReservation)
		return (
			<Redirect
				to={`/reserve/${officeSlug}/${lineSlug}/${currentReservation}`}
			/>
		);

	return (
		<OfficeDesktopLayout user={user} office={office} title="Reservar hora">
			<Wizzard
				bookReservation={bookReservation}
				chosenTimeBlock={chosenTimeBlock}
				desktop
				handleMeet={handleMeet}
				handlerReservation={handlerReservation}
				isDniRequired={isDniRequired}
				isRutRequired={isRutRequired}
				line={line}
				loading={bookingLoading}
				office={office}
				onSelect={(tb) => setChoosenTimeblock(tb)}
				setFieldAnswers={setFieldAnswers}
				setIsRutModalVisible={setIsRutModalVisible}
				setMeetOrFace={setMeetOrFace}
				setReservationPayload={setReservationPayload}
				temporaryDni={temporaryDni}
				temporaryRut={temporaryRut}
				user={user}
				v2={v2}
				wantTemporary={wantTemporary}
			/>

			{isVisibleConfirmationModal === true && (
				<ConfirmationModal label="¡Registro exitoso!" />
			)}
			<LoginModal
				blockreservation={chosenTimeBlock}
				getReservation={bookReservation}
				handleMeet={handleMeet}
				handleOpenUpdateRutModal={handleOpenUpdateRutModal}
				isActiveLoginModal={isActiveLoginModal}
				isRutRequired={isRutRequired}
				isDniRequired={isDniRequired}
				isSignUpModalActive={isActiveRegistryModal}
				onClose={closeLoginModal}
				openRutUpdateModal={setOpenRutUpdate}
				openWithoutLoginModal={handlerWithoutLoginModal}
				setIsRutModalVisible={setIsRutModalVisible}
				setModalState={setModalState}
				setWantTemporary={setWantTemporary}
				ticketAction={ticketAction}
				visible={loginModalIsVisible}
				fieldsAnswers={fieldsAnswers}
			/>
			<SignUpModal
				blockreservation={chosenTimeBlock}
				getReservation={bookReservation}
				handleMeet={handleMeet}
				handleOpenUpdateRutModal={handleOpenUpdateRutModal}
				isActive={isActiveLoginModal}
				onClose={closeSignUpModal}
				openRutUpdateModal={setOpenRutUpdate}
				openWithoutLoginModal={handlerWithoutLoginModal}
				setIsVisibleConfirmationModal={setIsVisibleConfirmationModal}
				ticketAction={ticketAction}
				visible={signUpModalIsVisible}
			/>
			{/* 			<ReserveWithoutLogin
				isLoginModalActive={isActiveLoginModal}
				openSignUp={activeSignUpModalInTemporaryUser}
				ticketAction={ticketAction}
				visible={isVisibleModalWithoutLogin}
				onClose={closeReserveWihtoutLogin}
				getReservation={bookReservation}
				blockreservation={chosenTimeBlock}
				handleMeet={handleMeet}
			/> */}
			<ReservationDocumentModal
				blockreservation={chosenTimeBlock}
				documentModalType={documentModalType}
				getReservation={bookReservation}
				handleMeet={handleMeet}
				handlerReservation={handlerReservation}
				isDni={isDniRequired}
				isDniRequired={isDniRequired}
				isLoginModalActive={isActiveLoginModal}
				isRutRequired={isRutRequired}
				onClose={() => setIsRutModalVisible(false)}
				openSignUp={activeSignUpModalInTemporaryUser}
				reservationPayload={reservationPayload}
				setIsRutUpdating={setIsRutUpdating}
				setTemporaryDni={setTemporaryDni}
				setTemporaryRut={setTemporaryRut}
				setWantTemporary={setWantTemporary}
				temporaryRut={temporaryRut}
				temporaryDni={temporaryDni}
				ticketAction={ticketAction}
				visible={isRutModalVisible}
			/>
		</OfficeDesktopLayout>
	);
};

const Step1 = ({ onSubmit, maxBookableDays, unavailableDays }) => {
	const [date, setDate] = useState(moment());
	let isPanelChange = false;
	const onPanelChange = () => (isPanelChange = true);
	const onChange = (date) => !isPanelChange && onSubmit(date);
	const onSelect = (d) => {
		if (!isPanelChange && date && date.date() === d.date()) {
			isPanelChange = false;
			onSubmit(d);
		}
		setDate(d);
	};
	// this use of useMemo is unjustified
	const validRange = useMemo(
		() => [
			moment().subtract(1, "days"),
			moment()
				.clone()
				.add(maxBookableDays || 30, "days"),
		],
		[maxBookableDays]
	);
	return (
		!!validRange.length && (
			<Calendar
				style={{ width: "60%", margin: "0 auto" }}
				disabledDate={(d) =>
					d.isBefore(moment().subtract(1, "days")) ||
					unavailableDays.some((d1) => d.isSame(d1, "day"))
				}
				validRange={validRange}
				fullscreen={false}
				locale={antLocale}
				onChange={onChange}
				onSelect={onSelect}
				onPanelChange={onPanelChange}
			/>
		)
	);
};

const Step3 = ({ onSubmit, datetime, lineName, officeName, loading }) => {
	return (
		<ConfirmReservation>
			<LeftPanel>
				<div>
					<Info>Día y hora de la reserva</Info>
					<Emphasis>{datetime}</Emphasis>
				</div>
				<div>
					<Info>En la fila:</Info>
					<Emphasis>{lineName}</Emphasis>
				</div>
				<div>
					<Info>Sucursal:</Info>
					<Emphasis>{officeName}</Emphasis>
				</div>
			</LeftPanel>
			<RightPanel>
				<LoginButton
					stroke="#783189"
					fill="#fff"
					label="Confirmar reserva"
					onClick={onSubmit}
					loading={loading}
					disabled={loading}
				/>
			</RightPanel>
		</ConfirmReservation>
	);
};

const Info = styled.div`
	font-size: 12px;
	font-weight: 700;
`;

const Emphasis = styled.div`
	font-weight: 800;
	font-size: 18px;
	color: #783189;
`;

const ConfirmReservation = styled.div`
	display: flex;
	flex-direction: row;
	box-shadow: -4px 6px 26px -4px rgba(120, 120, 120, 1);
	border-radius: 10px;
	margin: 0 auto;
`;

const RightPanel = styled.div`
	background-color: #783189;
	display: flex;
	flex-grow: 1;
	justify-content: center;
	align-items: center;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	padding: 18px;
	min-width: 200px;
`;

const LeftPanel = styled.div`
	flex-grow: 2;
	padding: 55px;
	align-content: space-between;
	& > div {
		margin-bottom: 10px;
	}
`;

export default Provider(RequestReservationScreen);
